import { render } from "./Index.vue?vue&type=template&id=464dbdc4"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/WEBIS WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__